
import { ToolLayout } from "@/components/tools/ToolLayout";
import { FairClickContainer } from "@/components/fairclick/FairClickContainer";
import { MetaTags } from "@/components/seo/MetaTags";
import { getFairClickSchema } from "@/components/fairclick/schemaUtils";

const FairClickPage = () => {
  const fairClickSchema = getFairClickSchema();
  
  return (
    <>
      <MetaTags
        title="FairClick | Générateur de trafic équitable"
        description="Échangez des visites de manière éthique et gagnez du trafic en visitant les sites des autres."
        schema={fairClickSchema}
        isToolPage={true}
      />
      <ToolLayout
        toolName="FairClick"
        title="FairClick | Générateur de trafic équitable"
        description="Échangez des visites de manière éthique et gagnez du trafic en visitant les sites des autres."
        breadcrumbs={[
          { label: 'Accueil', path: '/welcome' },
          { label: 'FairClick', path: '/fairclick' }
        ]}
        reliabilityLevel={3}
        maxWidth="3xl"
        className="px-1 sm:px-3"
      >
        <FairClickContainer />
      </ToolLayout>
    </>
  );
};

export default FairClickPage;
